export default __webpack_public_path__ + "static/media/amazon-vpc.50318847.svg";